/**
 * Angular import.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

/**
 * Rxjs import.
 */
import { Subscription } from 'rxjs';

/**
 * Service import.
 */
import { GetService } from '../../dataservice/get.service';
import { LanguageService } from '../../dataservice/language.service';

/**
 * Import interface.
 */
import { Product } from '../../../interface/doctalkSeries.model';

/**
 * Doctalk series detail component.
 */
@Component({
  selector: 'app-doctalk-series',
  templateUrl: './doctalk-series.component.html',
  styleUrls: ['./doctalk-series.component.css']
})
export class DoctalkSeriesComponent implements OnInit, OnDestroy {

  /**
   * Doctalk series referId.
   */
  @Input() referalId;

  /**
   * Doctalk series detail product type.
   */
  @Input() productType;

  /**
   * Doctalk series product type Id.
   */
  @Input() productTypeId;

  /**
   * Doctalk detail variable.
   */
  public doctalkSeriesDetail: Product;

  /**
   * Error message from api.
   */
  public errorMsg: string;

  /**
   * Doctalk seriest type.
   */
  public doctalkSeriesTalkType = 36;

  /**
   * Subscribe/Unsubscribe meeting detail.
   */
  public doctalkDetaillSubscription: Subscription;

  /**
   * Function used to import services from outside of this component
   */
  constructor(public getApiService: GetService, public mls: LanguageService) { }

  /**
   * Calling contentDetailShare function.
   */
  ngOnInit(): void {
    this.contentDetailShare();
  }

  /**
   * Get share content detail.
   */
  contentDetailShare(): void {
    if (this.getApiService.is_login == '1') {
      this.getApiService.navigateToSection(this.doctalkSeriesTalkType, this.productTypeId);
    }
    this.doctalkDetaillSubscription = this.getApiService.getContentShare(this.productType, this.productTypeId, this.referalId)
      .subscribe(data => {
        if (data.status === 1) {
          this.doctalkSeriesDetail = data.data.mix_list[0].products[0];
        } else {
          this.errorMsg = data.error.msg;
        }
      });
  }

  /**
   * Navigate user to doctalk series.
   */
  navigatetoDetail(): void {
    this.getApiService.navigateToSection(this.doctalkSeriesTalkType, this.productTypeId);
  }

  /**
   * Function used to unsubscribe all subscription
   */
  ngOnDestroy(): void {
    if (this.doctalkDetaillSubscription) {
      this.doctalkDetaillSubscription.unsubscribe();
    }
  }

}
